import { sentryModel } from '@/shared/model';

export const getDecodedBase64Deeplink = (encodedString: string) => {
  try {
    const decodedString = atob(encodedString);
    // Do not allow origins different from current one, since it may lead to security issues
    if (
      !decodedString.startsWith('/') &&
      !decodedString.startsWith(window.location.origin)
    ) {
      return '/';
    }

    return decodedString;
  } catch (error) {
    sentryModel.captureException(
      sentryModel.getReadableError(
        'ERR_FAILED_TO_PARSE_BASE64_DEEPLINK',
        error as Error,
      ),
      {
        extra: {
          base64String: encodedString,
        },
      },
    );
    return '/';
  }
};
